import React from 'react'
import Toast from './Toast'
import {toJS} from '../../../util/ToJS'
import {connect} from 'react-redux'
import {selectToasts, hideToast} from '../../../redux/modules/toast'
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group'
import './toast.css'

class ToastManager extends React.PureComponent {
  constructor(props) {
    super(props)
    this.toastRefs = []
    this.timeouts = {}
    this.fontSize = parseInt(window.getComputedStyle(document.body).getPropertyValue('font-size').slice(0, -2),10)
  }
  componentDidUpdate() {
    const {toasts, hideToast} = this.props
    
    //Ensure that the spacing between toasts is preserved for variable sizes.
    if (this.toastRefs.length) {
      let minHeight = 3.8125 * this.fontSize // height of a one line toast
      let marginAmount = 0
      for (let index in this.toastRefs) {
        if (this.toastRefs[index]) {
          this.toastRefs[index].style.marginBottom = `${marginAmount}px`
          marginAmount += this.toastRefs[index].clientHeight - minHeight
        }
        if (toasts[index] && toasts[index].timeout && !Object.prototype.hasOwnProperty.call(this.timeouts, toasts[index].id)) {
          this.timeouts[toasts[index].id] = setTimeout(()=>hideToast(toasts[index].id), toasts[index].timeout)
        }
      }
    }
  }
  componentWillUnmount() {
    for (let key in this.timeouts) {
      clearTimeout(this.timeouts[key])
    }
  }
  render() {
    const {toasts, hideToast} = this.props
    toasts.reverse()
    return (
      <div style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: 0,
        zIndex: 9999
      }}>
        <TransitionGroup className='toasts'>
          {
            toasts.map((t, index) => {
              const toastStyle = {
                position: 'absolute',
                padding: `0 .25rem`,
                transition: 'bottom 0.2s ease, opacity 100ms ease-in',
                bottom: (4.6875 * this.fontSize * (index + 1)),
                left: '50%',
                transform: 'translateX(-50%)',
                boxSizing: 'border-box',
                cursor: 'pointer'
              }
              return (
                <CSSTransition
                  key={t.id}
                  timeout={150}
                  classNames="toast-fade"
                >
                  <div
                    ref={(node) => this.toastRefs[index] = node}
                    onClick={() => hideToast(t.id)}
                    style={toastStyle}>
                    <Toast {...t} />
                  </div>
                </CSSTransition>
              )
            })
          }
        </TransitionGroup>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  hideToast: (id) => dispatch(hideToast(id))
})

export default connect(
  selectToasts,
  mapDispatchToProps
)(toJS(ToastManager))



// WEBPACK FOOTER //
// ./src/core/components/toasts/ToastManager.js